import { useCallback, useReducer } from 'react';

const formReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'INPUT_CHANGE':
      let formIsValid = true;
      for (const inputId in state.inputs) {
        if (!state.inputs[inputId]) continue;
        if (inputId === action.inputId) {
          formIsValid = formIsValid && action.isValid;
        } else {
          formIsValid = formIsValid && state.inputs[inputId].isValid;
        }
      }
      return {
        ...state,
        inputs: {
          ...state.inputs,
          [action.inputId]: { value: action.value, isValid: action.isValid },
        },
        isValid: formIsValid,
      };

    case 'SET_DATA':
      return {
        ...state,
        inputs: action.inputs,
        isValid: action.formValidity,
      };
    
    case 'SUBMIT_CHECK':
      formIsValid = true;
      for (const inputId in state.inputs) {
        if (!state.inputs[inputId]) continue;
        if (inputId === action.inputId) {
          formIsValid = formIsValid && action.isValid;
        } else {
          formIsValid = formIsValid && state.inputs[inputId].isValid;
        }
      }
      return {
        ...state,
        isValid: formIsValid,
      }
    
    case 'SET_SUBMITTED':
      return {
        ...state,
        isSubmitted: action.isSubmitted,
      };
    
    default:
      break;
  }
};

export const useForm = (initialInputs: any, initialFormValidity: any) => {
  const [formState, dispatch] = useReducer(formReducer, {
    inputs: initialInputs,
    isValid: initialFormValidity,
    isSubmitted: false
  });

  const inputHandler = useCallback((id, value, isValid) => {
    dispatch({
      type: 'INPUT_CHANGE',
      value,
      isValid,
      inputId: id,
    });
  }, []);

  const setFormDate = useCallback((inputData, formValidity) => {
    dispatch({
      type: 'SET_DATA',
      inputs: inputData,
      formIsValid: formValidity,
    });
  }, []);

  const submitCheck = useCallback((inputData) => {
    dispatch({
      type: 'SUBMIT_CHECK',
      inputs: inputData,
    });
  }, []);

  const setSubmitted = useCallback((isSubmitted: boolean) => {
    dispatch({
      type: 'SET_SUBMITTED',
      isSubmitted: isSubmitted,
    });
  }, []);

  return [formState, inputHandler, setFormDate, submitCheck, setSubmitted];
};
